<template>
  <MDBFooter :text="['center', 'lg-start']" class="fixed-bottom">
    <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2)">
      © 2019-2025  
      <a class="text-dark" href="https://hotliner.me/">hotliner</a> by <a class="text-dark" href="https://wireshout.com/">WireShout</a>
    </div>
  </MDBFooter>
</template>

<script>
import { MDBFooter } from "mdb-vue-ui-kit";

export default {
  name: "FooterElem",
  components: {
    MDBFooter,
  },
};
</script>